import { useTranslation } from 'react-i18next';
import { useIsPage } from './useIsPage';

export const useDataLockerTitle = () => {
  const { t } = useTranslation(['navigation', 'entity']);

  const isPlayerDataLocker = useIsPage('data-locker/players');
  const isTeamDataLocker = useIsPage('data-locker/teams');
  const isEventDataLocker = useIsPage('data-locker/events');

  if (isPlayerDataLocker) return t('crossPlatform.secondary.playerScout');
  if (isTeamDataLocker) return t('team.other', { ns: 'entity' });
  if (isEventDataLocker) return t('event.other', { ns: 'entity' });
  return t('crossPlatform.primary.explore'); // data locker landing page
};
